import React, {Component} from 'react';
import styled from "styled-components";
import { pure } from 'recompose';
import withLocalized from '../../../localization/withLocalized';
import { media } from "../ui/utils";
import colors from '../../../common/components/ui/colors';
import Button from '../button/Button';

const KEY = 'accept_cookie_policy';

const PolicyPlaceholder = styled.div`
    height: 3.75rem;
    padding: 0 1rem;
    transition: 0.25s height ease-out;
    ${media.tabletWide`
        height: 5.3125rem;  
        padding: 0 2rem;
    `}
    ${props => props.hide && `
        height: 0 !important;
    `}
`

const PolicyWrap = styled.div`
    overflow: hidden;
    height: 3.75rem;
    padding: 0 1rem;
    transition: 0.25s height ease-out;
    box-shadow: 0 -3px 5px 0 rgba(0, 0, 0, 0.07);
    ${media.tabletWide`
        height: 5.3125rem;  
        padding: 0 2rem;
    `}
    ${media.notTabletWide`
        font-size: .9rem;
    `}
    ${props => props.hide && `
        height: 0 !important;
    `}
    position: fixed;
    background: white;
    width: 100%;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1;
    box-sizing: border-box;
    display: flex;
    align-items: center;
`;

const StyledWrap = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    max-width: 590px;
    opacity: 1;
    transition: 0.2s opacity ease-out;
    ${props => props.hide && `
        opacity: 0;
    `}
    ${media.tabletWide`
        max-width: 100%;
    `} 
    ${media.desktopNarrow`
        justify-content: center;
    `}
`;

const PolicyText = styled.p`
    display: none;
    margin-right: 10px;
    ${media.tabletNarrow`
    display: inline-block;
    `}
    ${media.tabletWide`
        margin-right: 20px;
    `}
`;

const MoreLink = styled.a`
    &:before{
        content: '';
        height: 0;
        display: block;
    }
    color: ${colors.FIELD_ERROR};
    &:hover{
        text-decoration: underline;
    }
    ${media.desktopNarrow`
        display: inline-block;
    `}
`;

const TinyLink = styled.a`
    display: inline-block;
    padding: 0 0 0 10px;
    font-weight: bold;
    color: ${colors.BRAND_GREEN};
    ${media.tabletNarrow`
        display: none;
    `}
`;

const StyledButton = styled(Button)`
    ${media.notPhoneWide`
        padding-left: .75rem;
        padding-right: .75rem
    `}
    ${media.notTabletWide`
        font-size: .9rem;
    `}

`

class CookiesPolicy extends Component{
    constructor(props){
        super(props)
        this.state = {
            hidden: true,
            hide: undefined
        }
    }
    componentDidMount(){
        try{
            this.setState({
                hidden: localStorage.getItem(KEY)
            }, this.hide)
        }
        catch(e){}
    }

    setHidden = () => {
        try { localStorage.setItem(KEY, true) } catch (e) { }
    }

    hideCookiePolicy = (event) => {
        event.preventDefault()
        this.setState({
            hide: true
        }, this.setHidden)
    }
    
    render(){
        const { localized, cookiePageHref } = this.props;
        const { hidden, hide } = this.state
        if (hidden){
            return null
        }
        return (
            <PolicyPlaceholder hide={hide}>
                <PolicyWrap hide={hide}>
                    <StyledWrap hide={hide}>
                        <PolicyText>
                            {localized('cookies.cookie_policy_text')} <MoreLink href={cookiePageHref}>{localized('cookies.cookie_policy_link_text')}</MoreLink>.
                        </PolicyText>
                        <StyledButton
                            inverse
                            notransform
                            onClick={event => this.hideCookiePolicy(event)}
                        >
                        {localized('cookies.cookie_policy_accept_text')}
                        </StyledButton>
                        <TinyLink href={cookiePageHref}>?</TinyLink>
                    </StyledWrap>
                </PolicyWrap>
            </PolicyPlaceholder>
        )
    }

}

export default pure(withLocalized(CookiesPolicy));



// WEBPACK FOOTER //
// ./src/modules/common/components/app/CookiesPolicy.js